import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Project } from "../model/project";
import { ReferenceData } from "../model/reference-data";
//import { RefStatusData } from "../model/reference-status-data";

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  private baseUrl: string;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.spApiUrl;
  }

  public getProjects(clientId: string): Observable<any> {
    console.log("Get all projects data..");
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<Project[]>(this.baseUrl.concat("/projects/client/").concat(clientId), {headers: headers});
  }

  public getProject(projectId: string): Observable<any> {
    console.log("Get project data by.."+projectId);
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<Project>(this.baseUrl.concat("/projects/").concat(projectId), {headers: headers});
  }

  public getClientAndProjectInfo(schedulerId: string): Observable<any> {
    console.log("Get client and project info by.."+schedulerId);
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<Project>(this.baseUrl.concat("/projects/scheduler/").concat(schedulerId), {headers: headers});
  }

  public getRefernceData(): Observable<any> {
    console.log("Get all reference data..");
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<ReferenceData>(this.baseUrl.concat("/references"), {headers: headers});
  }

  public getProjectList(projectIds: number[]): Observable<any> {
    console.log("Get Projects data by.."+projectIds);
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<any>(this.baseUrl.concat("/projects/projectIds"), projectIds, {headers: headers});
  }

  public getProjectsByClientIds(clientIds: number[]): Observable<any> {
    console.log("Get all projects data by client ids.."+clientIds);
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<Project[]>(this.baseUrl.concat("/projects/clients/"), clientIds, {headers: headers});
  }


//   public getReferenceDataForStatus(): Observable<any> {
//     console.log("Get Status reference data..");
//     const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
//     return this.http.get<RefStatusData>(this.baseUrl.concat("/references/status"), {headers: headers});
//   }
}
